import React from "react";
import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";
import { IMAGES } from "../../data";
import { useLang } from "../../i18n";

export const Manifesto = () => {
  const { t } = useLang();
  const m = t.manifesto;
  return (
    <section
      id="why"
      data-testid="manifesto-section"
      className="relative py-24 sm:py-32 bg-[#060c1f]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-6 lg:gap-12">
          <div className="lg:col-span-5 lg:sticky lg:top-28 self-start">
            <Reveal>
              <SectionLabel num="[ 01 ]">{m.label}</SectionLabel>
              <h2 className="font-head font-extrabold uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.9]">
                {m.title1}
                <span className="block text-gold-grad">{m.title2}</span>
              </h2>
              <p className="mt-6 text-slate-400 leading-relaxed max-w-md">{m.intro}</p>
              <div className="mt-8 overflow-hidden rounded-xl border border-white/10">
                <img src={IMAGES.safety} alt="Warehouse safety team" className="w-full h-56 object-cover" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            {m.items.map((item, i) => (
              <Reveal key={item.no} delay={i * 0.05}>
                <motion.div
                  className="group border-t border-white/10 py-8 flex gap-5 sm:gap-8"
                  whileHover={{ x: 6 }}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                >
                  <span className="font-head font-extrabold text-3xl sm:text-4xl text-white/15 group-hover:text-amber-400 transition-colors shrink-0">
                    {item.no}
                  </span>
                  <div>
                    <h3 className="font-head font-bold uppercase tracking-wide text-2xl sm:text-3xl text-white">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-slate-400 leading-relaxed">{item.body}</p>
                  </div>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
